import { useMemo, useState } from 'react';
import { OLCHAM_DEFAULT, OLCHAM_TANLOV } from './usePagedQuery';

/**
 * MIJOZ TOMONIDA sahifalash — ro'yxat allaqachon TO'LIQ olingan bo'lsa.
 *
 * Nega serverda emas: ba'zi ro'yxatlarni bo'lib olish MUMKIN EMAS, chunki
 * qiymat butun to'plamga bog'liq. Eng aniq misol — reyting: o'rin raqami
 * hamma o'quvchi bo'yicha hisoblanadi, 10 tasini olib kelib "1–10 o'rin"
 * deb bo'lmaydi. Shuning uchun server hammasini hisoblaydi, brauzer esa
 * faqat KO'RSATISHNI bo'ladi.
 *
 * Muammo shunda emaski, 584 qator tarmoqdan keladi — u baribir keladi.
 * Muammo shuki, 584 qatorni DOM ga chizish sahifani sezilarli sekinlashtiradi
 * va uzun ro'yxatda kerakli qatorni topish qiyin.
 *
 * `usePagedQuery` bilan BIR XIL shakl qaytaradi, shuning uchun
 * `<TablePagination>` hech qanday o'zgarishsiz ishlaydi.
 */
export function useClientPaged<T>(items: T[], key: string, boshlangich = OLCHAM_DEFAULT) {
  const [page, setPage] = useState(1);
  const [limit, setLimitHolat] = useState(() => oqi(key, boshlangich));

  const setLimit = (n: number) => {
    setLimitHolat(n);
    yoz(key, n);
    setPage(1);
  };

  const total = items.length;
  const pages = Math.max(1, Math.ceil(total / limit));
  /* Ro'yxat qisqarsa (filtr qo'llanganda) joriy sahifa mavjud bo'lmay qolishi
     mumkin — bo'sh jadval ko'rsatmaslik uchun oxirgisiga tushamiz. */
  const joriy = Math.min(page, pages);

  const kesilgan = useMemo(
    () => items.slice((joriy - 1) * limit, joriy * limit),
    [items, joriy, limit]
  );

  return { items: kesilgan, total, pages, page: joriy, setPage, limit, setLimit };
}

const LS = 'sata:limit:';

function oqi(key: string, zaxira: number): number {
  try {
    const v = Number(localStorage.getItem(LS + key));
    return OLCHAM_TANLOV.includes(v) ? v : zaxira;
  } catch {
    return zaxira;
  }
}

function yoz(key: string, n: number): void {
  try { localStorage.setItem(LS + key, String(n)); } catch { /* muhim emas */ }
}
